import slide1 from "../assets/slide1.jpeg"
import slide2 from "../assets/slide2.jpg"
import slide3 from "../assets/slide3.jpg"
import slide4 from "../assets/slide4.jpg"
import event1 from "../assets/45.jpg"
import event2 from "../assets/bday.jpg"
import event3 from "../assets/lohri.jpg"
import event4 from "../assets/62.jpg"

export const sliderData = [
  {
    image: slide2,
    heading: "Wedding at Goa Beach",
    desc: "Creating magical moments with stunning beach weddings and unforgettable celebrations.",
  },
  {
    image: event1,
    heading: "Elegant Wedding Celebrations",
    desc: "Transforming your special day into a beautiful memory that lasts forever.",
  },
  {
    image: event2,
    heading: "Birthday Bash Extravaganza",
    desc: "Making birthdays memorable with creative themes and joyful celebrations.",
  },
  {
    image: slide3,
    heading: "Grand Event Management",
    desc: "Professional event planning and execution for all your special occasions.",
  },
  {
    image: event3,
    heading: "Cultural Celebrations",
    desc: "Bringing traditional festivals to life with vibrant decorations and entertainment.",
  },
  {
    image: slide4,
    heading: "Corporate Events & Parties",
    desc: "Sophisticated event solutions for corporate gatherings and celebrations.",
  },
  {
    image: event4,
    heading: "Luxury Wedding Decor",
    desc: "Exquisite decorations and setups that make your wedding dreams come true.",
  },
  {
    image: slide1,
    heading: "Photography & Memories",
    desc: "Capturing every precious moment with professional photography services.",
  },
];